import * as React from 'react';
import { useSelector } from 'react-redux';

import { getDeviceType, getCategory, getChartsData, getChartsLoading } from '../../selectors';
import { ChartFactory } from './ChartFactory';
import { EChartType } from '../../types/charts';
import { getLabelText } from './utils/getLabelText';
import { getDealTypeForChart } from './utils/getDealTypeForChart';
import { useIsMobile, useIsNotDesktop } from '../../components/Responsive';
import { EBlockInPageName } from '../../types/share';
import { useOnHover } from './utils/useOnHover';
import { useOnSwipe } from './utils/useOnSwipe';

export function ChartMortgageContainer() {
  const chartData = useSelector(getChartsData('mortgage'));
  const isMobile = useIsMobile();
  const isNotDesktop = useIsNotDesktop();
  const isLoading = useSelector(getChartsLoading);
  const category = useSelector(getCategory);
  const chartDealType = getDealTypeForChart(category);
  const firstLabel = isMobile ? '' : getLabelText(chartDealType, EChartType.Mortgage);
  const deviceType = useSelector(getDeviceType);

  const onHover = useOnHover(EBlockInPageName.MortgageRate, isNotDesktop);
  const onSwipe = useOnSwipe(EBlockInPageName.MortgageRate);

  if (chartData && chartData.chart) {
    return (
      <ChartFactory
        loading={isLoading}
        chartData={chartData.chart}
        deviceType={deviceType}
        dealType="sale"
        firstLabel={firstLabel}
        chartType={EChartType.Mortgage}
        onSwipe={onSwipe}
        onHover={onHover}
      />
    );
  }

  return null;
}
